import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { colorPalette } from '@sharefiledev/antd-config';
import { Button, Checkbox, Flex, theme, Typography } from 'antd';
import { Component } from '../../../common/componentUtils';
import { ICON_SIZE } from '../../../constants';
import { t } from '../../../utils';

const { Text } = Typography;
export const CheckboxesSettings = ({
	checkboxes,
	addCheckbox,
	removeCheckbox,
	selectedComponent,
	onClick,
}: {
	checkboxes: Component[];
	addCheckbox: () => void;
	removeCheckbox: (component: Component, index: number) => void;
	selectedComponent: Component;
	onClick: (checkbox: Component) => void;
}) => {
	const { token } = theme.useToken();
	const mappedCheckboxes = checkboxes.map((checkbox, index) => {
		const isChecked = false;
		const label = `${t('checkbox')} ${index + 1}`;
		const shouldHighlightText = checkbox.id === selectedComponent.id;

		return (
			<Flex
				key={checkbox.id}
				onClick={() => onClick(checkbox)}
				justify="space-between"
				style={{ marginBottom: token.marginXS }}
			>
				<Flex gap={token.marginXS}>
					<Checkbox checked={isChecked} disabled aria-label={label} />
					<Text style={{ color: shouldHighlightText ? colorPalette.lavender7 : '' }}>
						{label}
					</Text>
				</Flex>

				{checkboxes.length > 2 && (
					<CloseCircleOutlined
						size={ICON_SIZE}
						onClick={() => {
							removeCheckbox(checkbox, index + 1);
						}}
						data-testid="remove-checkbox-button"
						style={{ fontSize: '24px', color: colorPalette.neutral7 }}
					/>
				)}
			</Flex>
		);
	});

	return (
		<>
			{mappedCheckboxes}
			<Button size="small" onClick={addCheckbox} aria-label={t('addCheckbox')}>
				{t('addCheckbox')}
			</Button>
		</>
	);
};
